import landingManual from "./landingManual";
import landingPages from "./landingPages";
import landingSite from "./landingSite";
import landingReleases from "./landingReleases";

/**
 * `landing` 네임스페이스 — 공개 사이트(홈·서비스·플랜·문의·언론보도·매뉴얼·업데이트 소식) 문구. 모두 `site` 아래에 있고,
 * 파일이 커서 언어별로 사이트 틀·페이지·업데이트 소식·매뉴얼 파일로 나눠 합친다.
 */
const landing = {
  "site": { ...landingSite, ...landingPages, "releases": landingReleases, "manual": landingManual }
} as const;

export default landing;
